import { useContext } from 'react';
import {
  SidebarItemModalsContext,
  type SidebarItemModalsContextValue,
} from '../components/SidebarNavigation/SidebarItemModalsContext';

export function useSidebarItemModals(): SidebarItemModalsContextValue {
  return useContext(SidebarItemModalsContext);
}
